/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import RelayData from './RelayData';
import SensorData from './SensorData';

/**
 * The ControlByWebStatus model module.
 * @module model/ControlByWebStatus
 * @version 1.1.0
 */
class ControlByWebStatus {
    /**
     * Constructs a new <code>ControlByWebStatus</code>.
     * @alias module:model/ControlByWebStatus
     * @param connection {module:model/ControlByWebStatus.ConnectionEnum} 
     * @param relays {Array.<module:model/RelayData>} Array of relay objects
     * @param sensors {Array.<module:model/SensorData>} Array of sensor objects
     * @param serial {String} Unique serial number of the CBW device
     * @param timeLastUpdate {Date} Time the sensor and relay data was polled from the ControlByWeb
     */
    constructor(connection, relays, sensors, serial, timeLastUpdate) { 
        
        ControlByWebStatus.initialize(this, connection, relays, sensors, serial, timeLastUpdate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, connection, relays, sensors, serial, timeLastUpdate) { 
        obj['connection'] = connection;
        obj['relays'] = relays;
        obj['sensors'] = sensors;
        obj['serial'] = serial;
        obj['timeLastUpdate'] = timeLastUpdate;
    }

    /**
     * Constructs a <code>ControlByWebStatus</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ControlByWebStatus} obj Optional instance to populate.
     * @return {module:model/ControlByWebStatus} The populated <code>ControlByWebStatus</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ControlByWebStatus();

            if (data.hasOwnProperty('connection')) {
                obj['connection'] = ApiClient.convertToType(data['connection'], 'String');
            }
            if (data.hasOwnProperty('relays')) {
                obj['relays'] = ApiClient.convertToType(data['relays'], [RelayData]);
            }
            if (data.hasOwnProperty('sensors')) {
                obj['sensors'] = ApiClient.convertToType(data['sensors'], [SensorData]);
            }
            if (data.hasOwnProperty('serial')) {
                obj['serial'] = ApiClient.convertToType(data['serial'], 'String');
            }
            if (data.hasOwnProperty('timeLastUpdate')) {
                obj['timeLastUpdate'] = ApiClient.convertToType(data['timeLastUpdate'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ControlByWebStatus</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ControlByWebStatus</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ControlByWebStatus.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['connection'] && !(typeof data['connection'] === 'string' || data['connection'] instanceof String)) {
            throw new Error("Expected the field `connection` to be a primitive type in the JSON string but got " + data['connection']);
        }
        if (data['relays']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['relays'])) {
                throw new Error("Expected the field `relays` to be an array in the JSON data but got " + data['relays']);
            }
            // validate the optional field `relays` (array)
            for (const item of data['relays']) {
                RelayData.validateJSON(item);
            };
        }
        if (data['sensors']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['sensors'])) {
                throw new Error("Expected the field `sensors` to be an array in the JSON data but got " + data['sensors']);
            }
            // validate the optional field `sensors` (array)
            for (const item of data['sensors']) {
                SensorData.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['serial'] && !(typeof data['serial'] === 'string' || data['serial'] instanceof String)) {
            throw new Error("Expected the field `serial` to be a primitive type in the JSON string but got " + data['serial']);
        }

        return true;
    }


}

ControlByWebStatus.RequiredProperties = ["connection", "relays", "sensors", "serial", "timeLastUpdate"];

/**
 * @member {module:model/ControlByWebStatus.ConnectionEnum} connection
 */
ControlByWebStatus.prototype['connection'] = undefined;

/**
 * Array of relay objects
 * @member {Array.<module:model/RelayData>} relays
 */
ControlByWebStatus.prototype['relays'] = undefined;

/**
 * Array of sensor objects
 * @member {Array.<module:model/SensorData>} sensors
 */
ControlByWebStatus.prototype['sensors'] = undefined;

/**
 * Unique serial number of the CBW device
 * @member {String} serial
 */
ControlByWebStatus.prototype['serial'] = undefined;

/**
 * Time the sensor and relay data was polled from the ControlByWeb
 * @member {Date} timeLastUpdate
 */
ControlByWebStatus.prototype['timeLastUpdate'] = undefined;





/**
 * Allowed values for the <code>connection</code> property.
 * @enum {String}
 * @readonly
 */
ControlByWebStatus['ConnectionEnum'] = {

    /**
     * value: "CONNECTED"
     * @const
     */
    "CONNECTED": "CONNECTED",

    /**
     * value: "DISCONNECTED"
     * @const
     */
    "DISCONNECTED": "DISCONNECTED",

    /**
     * value: "ERROR"
     * @const
     */
    "ERROR": "ERROR"
};



export default ControlByWebStatus;

